module.exports = {
      id: "share-usage",
      viewBox: "0 0 13 13",
      url: "/" + "sprite-906bd948b42f12135087bdf480fde2e1.svg#share",
      toString: function () {
        return this.url;
      }
    }